import { define, ui, when } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/AlertMessage';

export default define`Alert Message`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/AlertMessage`,
  category: ui`Modules/Categories/Page/Customizable`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {
    type: ui`Choices`.of({
      black: 'Black',
      gray: 'Gray',
      error: 'Error',
      info: 'Info',
      other: 'Other',
      success: 'Success',
      warning: 'Warning',
    })({
      label: 'Alert Type',
      default: 'black',
    }),
    alertIcon: ui`Switch`({
      label: 'Alert Icon',
      default: true,
      visible: when`../type`.is.equal.to('gray').or.when`../type`.is.equal.to('other').or.when`../type`.is.equal
        .to('success')
        .then(false)
        .otherwise(true),
    }),
    title: ui`Text`({
      label: 'Title',
    }),
    message: ui`Text/Rich`({
      label: 'Message Content',
      default: 'This product has been discontinued.',
    }),
    dismissable: ui`Switch`({
      label: 'Dismissable',
      default: false,
    }),
  },
});
